import { SET_AUTH_PROPS } from '@glass/shared/modules/authForm';

const setAuthPropsAction = (payload = {}) => ({
  type: SET_AUTH_PROPS,
  payload,
});

export default setAuthPropsAction;
